import { render, staticRenderFns } from "./DialogBox.vue?vue&type=template&id=5aa1bbc9&scoped=true"
import script from "./DialogBox.vue?vue&type=script&lang=js"
export * from "./DialogBox.vue?vue&type=script&lang=js"
import style0 from "./DialogBox.vue?vue&type=style&index=0&id=5aa1bbc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa1bbc9",
  null
  
)

export default component.exports